import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { emailsAPI } from "api/Interactions/EmailsAPI";

interface AddEmailPopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newEmail: any) => void;
}

const AddEmailPopup: React.FC<AddEmailPopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Email"
      createFunction={emailsAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Title", required: true },
        { name: "description", label: "Description" },
        { name: "linked_campaign", label: "Campaign", required: true },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddEmailPopup;
